export const ADD_DEAL = 'ADD_DEAL';
export function addDeal(deal) {
  return {
    type: ADD_DEAL,
    deal
  };
}